/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type MemberManagementCreateMemberPointRequest = {
    memberId: number;
    type: MemberManagementCreateMemberPointRequest.type;
    note?: string | null;
    givePoint: number;
};

export namespace MemberManagementCreateMemberPointRequest {

    export enum type {
        LIVECARP = 'livecarp',
        STORE = 'store',
        CARPSALE = 'carpsale',
    }


}

